import { z } from 'zod';
import { employmentApi } from '../../../api';
import { EMPLOYMENT_EVENT_TYPES } from '../../../../constants/employmentEventTypes';
import { EVENT_ACTOR_TYPES } from '../../../../constants/employmentActorTypes';
import { employmentEpisodeIdSchema } from '../episodeAddress';

/**
 * Validation schema for termination finalization
 */
const finalizeTerminationSchema = z.object({
  employeeId: z.uuid(),
  employmentEpisodeId: employmentEpisodeIdSchema, // ADR-155 §6
  terminationDate: z.iso.date('Termination date must be in ISO format (YYYY-MM-DD)').optional()
});

/**
 * Finalize Termination
 *
 * @param {Object} payload - Termination data
 * @param {string} payload.employeeId - Required
 * @param {string} [payload.terminationDate] - Optional - ISO date format, uses resignDate if not provided
 * @param {string} [actorType='System'] - Actor type (System, User, Import)
 * @returns {Promise<Object>}
 * @throws {z.ZodError} - If validation fails
 */
export const finalizeTermination = async (payload, actorType = EVENT_ACTOR_TYPES.USER) => {
  // Validate payload
  const validatedPayload = finalizeTerminationSchema.parse(payload);

  return await employmentApi.triggerEmploymentEvents({
    metadata: {
      actorType
    },
    events: [{
      type: EMPLOYMENT_EVENT_TYPES.TERMINATION_FINALIZED,
      payload: validatedPayload
    }]
  });
};
